<template>
<el-dialog
  title="用户评价"
  :visible.sync="status"
  width="800px"
  :close-on-click-modal="false"
  @open="openInit"
  :before-close="esc">
  <div class="comment-form">
    <div class="cont-row">
        <div class="user-avator"><YorkbbsImage borderRadius="50%" width="30px" height="30px" :src="loginUser.avatar" animation></YorkbbsImage></div>
        <div class="flex-cont">
            <div class="content-input mrg-btm20"><el-input v-model="params.content" placeholder="大家都在问：菜品口味如何，服务态度好吗，环境（空间、布置）怎么样？" type="textarea" :rows="3" resize="none"></el-input></div>
            <div class="item-row mrg-btm20">
                <div class="lab">总体</div>
                <div class="cont"><SelectCommentScore ref="commentScore" /></div>
            </div>
            <div class="item-row mrg-btm20">
                <div class="lab">图片</div>
                <div class="cont"><OnlyUpload :disabled="params.imageList.length>=9" :limit="9-params.imageList.length" @success="imgUploadSuccess" /></div>
                <!-- <div class="video-upload" >
                    <input type="file" @change="fileUpload">
                    <i class="el-icon-video-camera"></i> 上传视频
                </div> -->
                <div class="upload-limit-note">最多上传9张图片</div>
            </div>
            <div class="item-row">
                <div class="lab"></div>
                <div class="flex-cont media-list">
                    <div class="item" v-for="(item,index) in params.imageList" :key="index">
                        <div class="box">
                            <div class="remove" @click="removeImgAt(index)"><i class="el-icon-close"></i></div>
                            <!-- <img :src="item" alt=""> -->
                            <YorkbbsImage :src="item" aspect></YorkbbsImage>
                        </div>
                    </div>
                    <div class="item" v-if="videoBuffer.length>0">
                        <div class="box">
                            <div class="remove" @click="removeVideo"><i class="el-icon-close"></i></div>
                            <!-- <img :src="item" alt=""> -->
                            <video :src="videoBuffer" controls></video>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-row mrg-btm20"  v-if="dishList.length >0 ">
                <div class="lab">推荐菜</div>
                <div class="flex-cont">
                    <!-- <el-radio-group v-model="params.dishIdList" class="dish-radio-group">
                        <el-radio v-for="item in dishList" :label="item.id" :key="item.id">{{ item.name }}</el-radio>
            
                    </el-radio-group> -->
                    <el-checkbox-group v-model="params.dishIdList" class="dish-radio-group">
                        <el-checkbox v-for="item in dishList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
                     
                    </el-checkbox-group>
                </div>
            </div>
            <div class="item-row mrg-btm30">
                <div class="lab">人均</div>
                <div class="cont"><el-input v-model.number="money" placeholder="请输入消费金额" size="small"><span class="input-prefix-money" slot="prefix">$</span></el-input></div>
            </div>
            <div class="item-row mrg-btm30">
                <div class="lab"></div>
                <el-button @click="esc" size="small">取消</el-button>
                <el-button type="primary" @click="ensure" size="small" :loading="postLoading">提交</el-button>
            </div>
        </div>
    </div>
  </div>
  <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="esc">取 消</el-button>
    <el-button type="primary" @click="ensure">确 定</el-button>
  </span> -->
</el-dialog>
</template>
<script>
import SelectCommentScore from './comment-score.vue'
import FormUploadButton from '@/common/form-upload/form-upload-button.vue'
import OnlyUpload from '@/common/only-uploadImg.vue'
import OSS from 'ali-oss';
export default {
    name:'DialogCommentPost',
    props:['post','status','parentCommentId'],
    components:{
        SelectCommentScore,
        FormUploadButton,
        OnlyUpload,
    },
    computed:{
        loginUser(){
            return this.$store.getters.user;
        }
    },
    data(){
        return {
            postLoading:false,
            showViewProgess:false,
            videoErr:false,
            videoBuffer:'',
            money:'',
            params:{
                "postId": "",
                // ****  parentCommentId  ****
                // 在对信息主体评论时传空字符串 ""
                // 对评论进行评论时传目标评论的id
                "parentCommentId": 0, 
                "stars": 0, // 评分
                "price": 0, // 人均价格，单位是CAD
                "content": "",
                "imageList": [
                    /* 'https://media5.imgyb.xyz/media/v1/image/d701516ecec2e0057fb4288689a02cec.jpeg',
                    'https://media3.imgyb.xyz/media/v1/image/3ab96be88b4925fd4204f8f376aa3ed7.jpeg', */
                ],
                "videoList": [], // 没有则传空数组
                "dishIdList": [] // 推荐菜id列表，没有则传空数组
            },
            dishList:[],
            selectDish:null,
        }
    },
    methods:{
        limitImage(){
            let result = 9- this.params.imageList.length + (this.videoBuffer.length==0?1:0)
          
            return result==0;
        },
        esc(){
            if( this.postLoading ) return false;
            this.$emit('update:status',false)
            this.params.content='';
            this.params.stars = 0;
            this.params.imageList = [];
            this.params.dishIdList=[];
            this.price = '';

        },
        async ensure(){
            if( this.postLoading ) return false;
            if( this.params.content.length == 0 ) return this.$warning('请留下您珍贵的意见');
            let sendData = {...this.params};
            let score = this.$refs.commentScore.score;
            if( score == 0 ) return this.$warning('请打出您的评分');
            sendData.stars = score;
            sendData.postId = this.post.id;
            if(this.money != ''&& this.money >0){
                sendData.price= parseFloat(this.money);
            }
            sendData.parentCommentId = this.parentCommentId;
            
            
            this.postLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/create/comment',sendData)
            this.postLoading = false;
            
            if( result.code == 0 ){
                this.$success('评论成功');
                this.esc();
                this.$emit('success');
            }
        },
        imgUploadSuccess(imgsrc){
            if( this.params.imageList.length <9){

                this.params.imageList.push(imgsrc);
            }
        },
        openInit(){
            this.ossInit();
            this.getDishList();
        },
        async getDishList(){
            let result = await this.$axios.post('/comment/frontend/v1/get/dish/list/of/post',{
                "postId": this.post.id,
                "typeIdList": [],
                "offset": 1,
                "size": 100
            })
            if( result.code == 0 ){
                
                this.dishList = result.data.dishList;
            }
        },
        async ossInit() {
            let result = await this.$axios.post('/ali/v1/sts/token', {});
            if (result.code != 0) {
                //this.$warning('视频上传功能异常，暂无法使用');
                //this.videoErr = true;
                return false;
            }
            this.videoErr = false;
            this.ossClient = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: "oss-us-west-1",
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: result.data.AccessKeyId,
                accessKeySecret: result.data.AccessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: result.data.SecurityToken,
                // 填写Bucket名称，例如examplebucket。
                bucket: "york-image",
            });


        },
        fileToMD5(file) {
            return new Promise((resolve) => {
                var fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);

                fileReader.onload = (result) => {
                    this.videoBuffer = result.target.result; 
                    
                    let md5Result = this.$md5.hex(result.target.result);

                    resolve(md5Result);
                }
            });

        },
         //视频上传
         async fileUpload(event) {

            let file = event.target.files[0];

            let fileName = await this.fileToMD5(file);
            if( Date.now() ) return;
            let fileNameSplitArr = file.name.split('.');
            let extendName = fileNameSplitArr[fileNameSplitArr.length - 1];
            const options = {
                // 获取分片上传进度、断点和返回值。
                progress: (p) => {

                    this.videoUploadPercentage = p * 100
                },
                // 设置并发上传的分片数量。
                parallel: 4,
                // 设置分片大小。默认值为1 MB，最小值为100 KB。 单位是kb
                partSize: 1024 * 1024,

            };
            this.showViewProgess = true;
            let result = await this.ossClient.multipartUpload(`/video/${fileName}.${extendName}`, file, {
                ...options,
                mime: "text/plain",
            })
            this.showViewProgess = false;
            this.params.videoList.push('https://media.canada-cn.net/media/v1' + result.name);
            
        },
        removeImgAt(index){
            this.params.imageList.splice(index,1);
        },
        removeVideo(){
            this.videoBuffer = [];
        }

    }
}
</script>
<style lang="scss" scoped>
.mrg-btm20{margin-bottom: 20px;}
.mrg-btm30{margin-bottom: 30px;}
.comment-form{
    .cont-row{
        display: flex;
        .user-avator{
            margin-right: 20px;
        }
        .flex-cont{flex:1;overflow: hidden;}
    }
    .input-prefix-money{font-size: 14px; font-weight: 400; color: #999; line-height: 28px; margin-left: 7px;}

    .item-row{
        display: flex;
        .lab{width:75px; line-height: 32px; color: #222; font-size: 16px;}
    }
    .video-upload{
        display: flex; align-items: center; font-size: 14px; line-height: 32px; padding: 0 10px; border-radius: 4px; position: relative; overflow: hidden;
        background: #e43a3a; color: #fff; margin-left: 20px;
        input{position: absolute; right: 0; top: 0; font-size: 30px; cursor: pointer;}
        i{font-size: 18px; margin-right: 5px;}
        &:hover{background: #e96161;}
    }
    .media-list{
        margin:0 -5px; display: flex; flex-wrap: wrap;
        .item{
            padding: 0 5px; margin-bottom: 10px; width: 20%;
            .box{
                position: relative;
                video{width:100%; aspect-ratio: 4/3; object-fit: cover;}
                .remove{
                    position: absolute; z-index:3 ; top: 0; right: 0;  height: 20px; padding: 0 5px; background: #000; border-radius: 0 0 0 8px; font-size: 18px; color: #fff; cursor: pointer;
                }
            }
        }
    }
}
.dish-radio-group{
    ::v-deep{

        label{
            position: relative; margin-right: 10px;
            border:1px solid #dcdfe6; border-radius: 4px; margin-bottom: 10px;
            .el-checkbox__input{
                position: absolute; left: 0; top: 0; opacity: 0;
            }
            .el-checkbox__label{
                padding: 0 10px; line-height: 30px; color:#333;
            }
            &.is-checked{
                border-color: #e43a3a;
            }
        }
    }
}
.upload-limit-note{font-size: 12px; line-height: 32px; color: #999; margin-left: 10px;}
</style>